// generated by genversion
export const version = '2.7.0';
//# sourceMappingURL=version.js.map